import type { Candidate } from '@/models/candidate';
import type { CandidateDoc } from '@/types/backend-contracts';

function buildCandidatePhotoUrl(slug: string): string {
  return `/candidatos/${encodeURIComponent(slug)}.jpg`;
}

function normalizeElectoralNumber(value: CandidateDoc['electoralNumber']): string | undefined {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return String(Math.trunc(value));
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : undefined;
  }

  return undefined;
}

export function toCandidateViewModel(candidate: CandidateDoc & { id: string }): Candidate {
  return {
    id: candidate.id,
    name: candidate.name,
    party: candidate.party,
    electoralNumber: normalizeElectoralNumber(candidate.electoralNumber),
    photoUrl: buildCandidatePhotoUrl(candidate.slug),
  };
}
